<template>
  <div :class="['ms-form ms-form--narrow', {purpose: this.data?.body?.purpose}]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomInput
          label="Сумма" type="number"
          :value="this.formData.ds_sum" :min="null"
          @change_input="(value) => onChange('ds_sum', value)"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomInput from "@/components/form/CustomInput";

export default {
  name: "change-ds-sum",
  components: {CustomInput, CustomModalFooter, },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        ds_sum: this.data?.body?.ds_sum || '',
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  },
}
</script>
